module.exports = __webpack_public_path__ + "static/img/create-team-left.3c6e76b8.png";